import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
  const { colors } = useContextState()
  return {
    section: {
      marginBottom: '32px'
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    },
    title: {
      flexGrow: 1,
      fontSize: '20px',//20
      fontWeight: '500',
    },
    switch: {
      '& .MuiFormControlLabel-label': { 
        /* fontSize: '0.9rem' */ 
        color: colors.color13,
        /* fontWeight:'bold' */
      }, 
      marginBottom: 2 
    }
  }
}

export { useStyles }
